import { getFilter } from 'api/filter'
import { URL_STRINGIFY_OPTIONS } from 'application/configuration/constants'
import { combine, createEffect, createEvent, createStore, restore } from 'effector'
import { createGate } from 'effector-react'
import { FilterValues } from 'features/filter/types'
import { appendUrl } from 'lib/append-url'
import { ReactElement } from 'react'

import { $relatedFilter } from '../../cars-list/model'
import { FilterDeclaration } from '.'

/**
 * Устанавливает одно значение фильтра
 */
export const replaceValues = createEvent<FilterValues>()

export const setValues = createEvent<FilterValues>()

export const mergeValues = createEvent<FilterValues>()

export const removeValues = createEvent<FilterValues>()

export const resetValues = createEvent()

export const hasCitySelection = createGate<{ enabled: boolean }>()

/**
 * Значения фильтра, плоский обект массивов вида {filterKey: [value1, value2], ...}
 */
export const $filterValues = createStore<FilterValues | null>(null)

export const $internalFilterValues = restore(setValues, null)

export const $disabledFilterValues = createStore<FilterValues | null>(null)

export const $defaultFilterValues = createGate<FilterValues>()

export const $permanentFilterValues = createGate<FilterValues>({ defaultState: {} })

/**
 * Из шапки подтягивается айди дилера, по которому ищем машины. Если не находим, меняем флаг на true
 */
export const $dealersShowMoreCars = createStore<{
  showCarsNextDealer: boolean
  dealers: Record<string, ReactElement>[]
}>({
  showCarsNextDealer: true,
  dealers: []
})

export const setNextDealer = createEvent<Record<string, ReactElement>>() // Ожидает строку с именем дилера
export const removeDealers = createEvent() // Сбросить состояние стора

export const setDealersInFilters = createEvent<(string | number)[]>()

$internalFilterValues.on(setDealersInFilters, (state, dealersIds) => ({
  ...state,
  dealer: [...dealersIds]
}))

$dealersShowMoreCars.on(setNextDealer, (state, dealer: Record<string, ReactElement>) => ({
  showCarsNextDealer: true,
  dealers: [...state.dealers, dealer]
}))

$dealersShowMoreCars.on(removeDealers, () => ({
  showCarsNextDealer: false,
  dealers: []
}))
/**
 *
 */
export const fetchDeclarationFx = createEffect(getFilter)

export const $fetchFailed = createStore(false).on(fetchDeclarationFx.fail, () => true)

export const $fetching = fetchDeclarationFx.pending

export const $declaration = createStore<null | FilterDeclaration>(null)

// создаём функцию, которая будет записать в store relatedFilter
export const setRelatedFiltersInsteadDeclaration = createEvent<any>()

// создаем store, где будем хранить relatedFilters
export const $declarationWithRelatedFilters = restore<any>(setRelatedFiltersInsteadDeclaration, null)

// вешаем событие on, которое будет срабатывать при вызове setRelatedFiltersInsteadDeclaration
// принимает relatedFilters и возвращает их, записываю в store
$declarationWithRelatedFilters.on(setRelatedFiltersInsteadDeclaration, (_, relatedFilters) => {
  return relatedFilters
})

export const $isFilterReady = combine($declaration, $fetching, $filterValues, (d, f, fi) => !!d && !f && !!fi)

export const getFilterValuesFromUrlFx = createEffect()

/**
 * Эффект сохранения значений фильтра в URL страницы
 */
export const propagateToURLFx = createEffect((data: FilterValues) => {
  const url = appendUrl({
    url: window.location.href,
    parseOptions: URL_STRINGIFY_OPTIONS,
    stringifyOptions: URL_STRINGIFY_OPTIONS,
    data
  })
  window.history.replaceState({}, '', url)
})
